<template>
  <div>
    <v-card elevation="2" outlined shaped tile class="mb-2">
      <v-card-title>Rutero GPV</v-card-title>

      <v-card-text class="text--primary">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12" sm="12" md="3">
              <v-menu
                ref="startDate_menu"
                v-model="select_startDate_menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="filterMainCredential.startDate"
                    v-bind:label="$t('start_date')"
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    readonly
                    required
                    :rules="requiredRules"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filterMainCredential.startDate"
                  no-title
                  @input="select_startDate_menu = false"
                  :first-day-of-week="1"
                  :locale="this.$i18n.locale"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <v-menu
                ref="endDate_menu"
                v-model="select_endDate_menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="filterMainCredential.endDate"
                    v-bind:label="$t('end_date')"
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    readonly
                    required
                    :rules="requiredRules"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filterMainCredential.endDate"
                  no-title
                  :min="filterMainCredential.startDate"
                  @input="select_endDate_menu = false"
                  :first-day-of-week="1"
                  :locale="this.$i18n.locale"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <v-autocomplete
                v-model="filterMainCredential.idGPV"
                v-bind:label="`GPV`"
                v-bind:placeholder="$t('start_typing_to_search')"
                item-text="fullname"
                item-value="id"
                :search-input.sync="search_gpvs"
                :loading="isSearching['gpvs']"
                :items="filtered_gpvs"
                hide-no-data
                hide-selected
                filled
                clearable
                required
                :rules="requiredRules"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <v-autocomplete
                v-model="filterMainCredential.companyCodes"
                :label="$t('Company')"
                v-bind:placeholder="$t('start_typing_to_search')"
                item-text="name"
                item-value="id"
                :search-input.sync="search_companies"
                :loading="isSearching['companies']"
                :items="filtered_companies"
                hide-no-data
                filled
                multiple
                clearable
                required
                :rules="requiredRulesArray"
                @change="onChangeCompany"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="3"
              class="d-flex justify-content-center"
            >
              <v-checkbox
                v-model="isOnlyActiveGPVs"
                label="Solo GPV's activos"
                hide-details="auto"
                @change="onChangeIsOnlyActiveGPVs"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="12" md="4" class="text-center">
              <v-btn color="blue darken-1" @click="onClickFilter">
                {{ $t("go") }}
              </v-btn>
              <v-btn
                color="warning"
                dark
                class="ml-2"
                :loading="isDownloading"
                @click="downloadExcel"
              >
                <b-icon icon="file-excel-fill" aria-hidden="true"></b-icon>
                Export Excel
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
        <p class="trencadis-title mb-0" v-if="this.mainRoute">
          Ruta <b> : {{ this.mainRoute?.name }}</b>
        </p>
        <v-row class="mb-2">
          <v-col cols="12" sm="12" md="12">
            <b-alert show variant="info" v-if="isLoadingData">
              <b-icon
                icon="arrow-counterclockwise"
                animation="spin-reverse"
              ></b-icon>
              cargando datos...
            </b-alert>
            <b-alert
              v-else-if="
                !isLoadingData &&
                  (!worksessionId ||
                    !filteredPosList ||
                    filteredPosList.length === 0)
              "
              variant="warning"
              class="m-0 mt-4 p-2 my-alert"
              show
            >
              <i> No hay datos....</i>
            </b-alert>
            <v-row
              v-else-if="
                !isLoadingData && filteredPosList && filteredPosList.length > 0
              "
            >
              <v-col cols="12" sm="12" md="12">
                <routePosList
                  :filteredPosList="filteredPosList"
                  :visitTypes="visitTypes"
                  :showDate="true"
                  :onClickRemoveAdditionalItem="onClickRemoveAdditionalItem"
                ></routePosList>
                <div class="table-pagination mt-2 text-right">
                  <ve-pagination
                    :total="totalPosCount"
                    :page-index="pageIndex"
                    :page-size="pageSize"
                    :page-size-option="pageOptions"
                    @on-page-number-change="pageNumberChange"
                    @on-page-size-change="pageSizeChange"
                  />
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ApiService from "@/services/apiService";
import { logInfo, logError } from "@/utils";
import download from "js-file-download";
import moment from "moment";
import routePosList from "@/views/session/routePosList.vue";

export default {
  name: "RouteGPV",
  components: {
    routePosList
  },
  data: function() {
    return {
      filter_main_credentials_fetch_url:
        "reporting/routegpv/getfiltermaincredentials",
      filterMainCredential: {
        companyCodes: [],
        startDate: null,
        endDate: null,
        idGPV: null
      },
      maxRangeDays: 31,

      pageIndex: 1,
      pageSize: 10,
      pageOptions: [10, 50, 100],
      totalPosCount: 0,

      user_route: null,
      isLoadingData: false,
      isDownloading: false,
      worksessionId: null,
      worksessionIds: [],
      session: null,
      meta: null,
      filteredPosList: null,
      visitTypes: [],
      isOnlyActiveGPVs: true,
      valid: true,
      requiredRules: [v => !!v || "Required"],
      requiredRulesArray: [v => (!!v && v.length > 0) || "Required"],
      search_gpvs: null,
      filtered_gpvs: [],
      search_companies: null,
      filtered_companies: [],
      isSearching: {},
      select_startDate_menu: false,
      select_endDate_menu: false
    };
  },
  watch: {
    async search_companies(val) {
      this.searchValues("companies", val);
    },
    async search_gpvs(val) {
      this.searchValues("gpvs", val);
    }
  },
  computed: {
    mainRoute() {
      let ret = null;
      if (this.user_route) {
        if (Array.isArray(this.user_route) && this.user_route.length > 0) {
          ret = this.user_route[0];
        }
      }
      return ret;
    }
  },
  methods: {
    onChangeIsOnlyActiveGPVs() {
      this.searchValues("gpvs", "");
    },
    onChangeCompany() {
      this.searchValues("gpvs", "");
    },
    async searchValues(fieldname, val) {
      if (!val) val = "";
      let fetch_url = `${this.filter_main_credentials_fetch_url}?column=${fieldname}&isFullText=true&filterValue=${val}`;
      let form_data = {
        ...this.filterMainCredential,
        isOnlyActiveGPVs: this.isOnlyActiveGPVs
      };
      this.isSearching[fieldname] = true;
      const resp = await ApiService.post(fetch_url, form_data);
      if (fieldname === "gpvs") {
        this.filtered_gpvs = resp.data;
      } else if (fieldname === "companies") {
        this.filterMainCredential.idGPV = null;
        this.filtered_companies = resp.data;
      }
      this.isSearching[fieldname] = false;
    },
    isValidDateRange() {
      const { startDate, endDate } = this.filterMainCredential;
      if (!startDate || !endDate) return false;
      if (endDate < startDate) {
        logError("La fecha final no puede ser anterior a la fecha inicial");
        return false;
      }
      const days = moment(endDate).diff(moment(startDate), "days") + 1;
      if (days > this.maxRangeDays) {
        logError(`El rango máximo permitido es de ${this.maxRangeDays} días`);
        return false;
      }
      return true;
    },
    async onClickFilter() {
      if (this.$refs.form.validate() && this.isValidDateRange()) {
        this.pageIndex = 1;
        this.initDay();
      }
    },
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
      this.getRouteDetails();
    },
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
      this.getRouteDetails();
    },
    // Exports the whole selected date range, not just the page on screen.
    async downloadExcel() {
      if (!this.$refs.form.validate() || !this.isValidDateRange()) return;
      this.isDownloading = true;
      try {
        let fetch_url = "reporting/routegpv/downloadexcel";
        let form_data = { ...this.filterMainCredential };
        const response = await ApiService.post(fetch_url, form_data, {
          responseType: "blob"
        });
        download(response, "rutero_gpv.xlsx");
      } catch (error) {
        logError("No se pudo generar el Excel");
      }
      this.isDownloading = false;
    },
    clearResults() {
      this.filteredPosList = [];
      this.totalPosCount = 0;
    },
    async onClickRemoveAdditionalItem(additionalIds) {
      console.log(additionalIds);
      if (additionalIds.length > 0 && confirm(this.$t("confirmdelete"))) {
        let fetch_url = "worksession/removeadditionalitems";
        let formdata = {
          additionalIds
        };
        let response = await ApiService.post(fetch_url, formdata);
        if (response.success) {
          this.getRouteDetails();
        }
      }
    },
    async getRouteDetails() {
      this.isLoadingData = true;
      let fetch_url = "reporting/routegpv/getRouteDetails";
      let form_data = {
        worksessionId: this.worksessionId,
        worksessionIds: this.worksessionIds,
        page: this.pageIndex,
        itemsPerPage: this.pageSize
      };
      try {
        const resp = await ApiService.post(fetch_url, form_data);
        if (resp?.ret) {
          const { data, meta, visitTypes, user_route } = resp.ret;
          this.user_route = user_route;
          this.visitTypes = visitTypes;
          this.session = data;
          this.meta = meta;
          this.totalPosCount = resp.total || 0;
          const { mergedPosData } = this.meta;
          this.filteredPosList = mergedPosData
            .map(el => {
              let item = { ...el };
              if (item.status.scheduleDateTime) {
                item.status.originalScheduleDateTime = moment(
                  item.status.originalScheduleDateTime
                )
                  .local()
                  .format("DD/MM/YYYY HH:mm");
              }
              // Shown as a badge on each row so the day is clear in a range.
              item.worksessionDateLabel = item.worksessionDate
                ? moment(item.worksessionDate).format("DD/MM/YYYY")
                : null;
              return item;
            })
            .filter(el => el);
        } else {
          this.clearResults();
        }
        this.isLoadingData = false;
      } catch (error) {
        this.isLoadingData = false;
      }
    },
    async initDay() {
      // initday
      this.isLoadingData = true;
      let fetch_url = "reporting/routegpv/initday";
      let form_data = { ...this.filterMainCredential };
      try {
        const resp = await ApiService.post(fetch_url, form_data);
        if (resp?.message) logError(resp.message);
        this.worksessionId = resp?.worksessionId || null;
        this.worksessionIds = (resp?.worksessions || []).map(el => el.id);
        if (this.worksessionIds.length > 0) {
          this.getRouteDetails();
        } else {
          this.clearResults();
          this.isLoadingData = false;
        }
      } catch (error) {
        this.isLoadingData = false;
      }
    },
    async init() {
      this.searchValues("gpvs", "");
      this.searchValues("companies", "");
    }
  },
  async mounted() {
    this.init();
  }
};
</script>

<style></style>
